import React from 'react'
import { useSelector } from 'react-redux'
import { i18n } from '@/locale/i18n'
import { selectActiveLanguage } from '@/store/app'
import { abbreviateAmount } from '@/util/localizeNumber'
import DeferredNumberFlow from '@/components/ui/deferred-number-flow'
import MarketStatsTooltip from './MarketStatsTooltip'

/**
 * The market's volume as a list row reports it: the figure alone, with no icon and no
 * visible label — the column header names it, and the row has no room to spend on a
 * glyph. That header is decoration a screen reader never reaches, so the figure carries
 * its own name here. Reads the currency split and the K/M abbreviation from the same
 * helpers the card footer uses, so a row and a card never report a market differently,
 * and opens the card's stats panel on hover for the full picture.
 */
const MarketVolumeStat = ({ question, isRealMoney = false, className = '' }) => {
  const locale = useSelector(selectActiveLanguage())
  const rawValue = (isRealMoney ? question?.volume_real_money : question?.volume_play_money) || 0
  const { value, abbr } = abbreviateAmount(rawValue)

  return (
    <MarketStatsTooltip
      question={question}
      locale={locale}
      className={`inline-flex w-fit cursor-default items-center gap-1 text-sm text-Neutral-4 ${className}`}>
      <span className="sr-only">{i18n('markets.volume')}</span>
      <DeferredNumberFlow
        locales={locale}
        value={value}
        format={{ style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: abbr ? 1 : 0 }}
        roundingMode="floor"
        prefix={isRealMoney ? '$ ' : ''}
        suffix={abbr + (isRealMoney ? '' : ' ø')}
      />
    </MarketStatsTooltip>
  )
}

export default MarketVolumeStat
